<template>
  <div class="AppHeader">
    <div v-if="content" class="titleBox">
      <el-page-header
        @back="goBack"
        title="返回"
        :content="content"
      ></el-page-header>
    </div>
    <div v-else class="titleBox">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

.AppHeader {
  .titleBox {
    background: white;
    border-radius: 2px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ::v-deep .el-page-header__left {
      color: map-get($colors, primary);
    }
  }
}
</style>
